export default __webpack_public_path__ + "static/media/shimmerSkeleton.5a85c7d3.png";